import { BASE_ERROR_CODES } from "./codes.mjs";
import { APIError as APIError$1 } from "better-call/error";
//#region src/error/index.ts
var BetterAuthError = class extends Error {
	constructor(message, options) {
		super(message, options);
		this.name = "BetterAuthError";
		this.message = message;
		this.stack = "";
	}
};
var APIError = class APIError extends APIError$1 {
	constructor(...args) {
		super(...args);
	}
	static fromStatus(status, body) {
		return new APIError(status, body);
	}
	static from(status, error) {
		return new APIError(status, {
			message: error.message,
			code: error.code
		});
	}
};
//#endregion
export { APIError, BASE_ERROR_CODES, BetterAuthError };
